/* Artes com texto gravado em português têm versão zh/en (mesma arte, texto traduzido). */
const LOCALIZED = new Set([
  'tab_usina_on', 'tab_usina_off', 'tab_envasadora_on', 'tab_envasadora_off',
  'tab_magnatas_on', 'tab_magnatas_off', 'tab_corretores_on', 'tab_corretores_off',
  'title_magnatas', 'title_corretores', 'title_mafia', 'title_procurados', 'card_procurado',
  'hero', 'top1_frame', 'ic_procurados',
]);

export const oilArt = (name, locale) =>
  `/oil/${name}${locale && locale !== 'pt' && LOCALIZED.has(name) ? `_${locale}` : ''}.webp`;
